export default "__VITE_ASSET__D$M_F5om__"